import React, { Component, PropTypes } from 'react';
import { FlatButton, Styles } from 'material-ui';
import * as ComponentIcons from 'components/Icons';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import { ToolbarGroup, ToolbarButton } from 'components/Toolbar';

const { Spacing } = Styles;

const styles = {
  root: {
    position: 'absolute',
    left: -(Spacing.iconSize + Spacing.desktopGutterMini * 4),
    top: 0
  },
  icon: {
    margin: 6
  },
  button: {
    lineHeight: `${36}px`,
    width: 36,
    height: 36,
    minWidth: 36,
    verticalAlign: 'middle'
  },
  withoutBorder: {
    border: 'none',
    margin: 0
  }
};

class Controls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCancelResize: false
    }
  }
  static displayName = 'Controls';

  static propTypes = {
    hoverColor: PropTypes.string,
    mode: PropTypes.oneOf(['edit', 'detail']),
    onSave: PropTypes.func,
    onDelete: PropTypes.func,
    onEditMode: PropTypes.func,
    opacity: PropTypes.number,
    moduleName: PropTypes.string,
    raw: PropTypes.bool
  };

  static defaultProps = {
    hoverColor: Colors.Colors.grey[500].material,
    opacity: 1
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.raw !== this.state.isCancelResize) {
      this.setState({isCancelResize: nextProps.raw})
    }
  }

  save() {
    if (this.props.onSave) {
      if (!this.props.raw && !this.state.isCancelResize) {
        this.props.onSave();
      } else {
        this.props.onSave({isCancelResize: this.state.isCancelResize});
      }
    }
  }

  delete() {
    if (this.props.onDelete) {
      this.props.onDelete();
    }
  }

  editMode() {
    if (this.props.onEditMode) {
      this.props.onEditMode();
    }
  }

  cancelResize() {
    this.setState({isCancelResize: !this.state.isCancelResize});
  }

  render() {
    const { mode, hoverColor, opacity, moduleName, ...other } = this.props;
    let control;
    if (mode === 'edit') {
      control = (
        <ToolbarGroup style={styles.withoutBorder}>
          {
            moduleName && moduleName === 'image' ?
              <ToolbarButton
                tooltip={this.state.isCancelResize ?
                  this.context.getIntlMessage('settings.enableScaling')
                :
                  this.context.getIntlMessage('settings.disableScaling')}
                onTouchTap={::this.cancelResize}>
                <ComponentIcons.SizeSelect
                  color={this.state.isCancelResize ? '#01c9cb' : '#000'}
                  width={24}
                  height={24}/>
              </ToolbarButton>
              :
              null
          }
          <ToolbarButton onTouchTap={::this.save}>
            <Icons.ActionVisibility hoverColor={hoverColor} />
          </ToolbarButton>
        </ToolbarGroup>
      );
    } else {
      control = (
        <ToolbarButton onTouchTap={::this.editMode}>
          <Icons.EditorModeEdit hoverColor={hoverColor} />
        </ToolbarButton>
      );
    }
    return (
      <ToolbarGroup {...other}>
        {control}
        <ToolbarButton onTouchTap={::this.delete}>
          <Icons.ActionDelete hoverColor={hoverColor} />
        </ToolbarButton>
      </ToolbarGroup>
    );
    // return (
    //   <Bubble width={Spacing.iconSize + Spacing.desktopGutterMini} opacity={opacity} style={{root: styles.root}}>
    //     {control}
    //     <ToolbarButton style={styles.button} onTouchTap={::this.delete}>
    //       <Icons.ActionDelete color={Colors.Colors.red[200].material} hoverColor={hoverColor}/>
    //     </ToolbarButton>
    //   </Bubble>
    // );
  }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/js/components/PageModule/Controls.js